//test
import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Badge,
  Label,
  Input,
  Form,
  InputGroup,
  FormFeedback,
} from "reactstrap"
import Select from "react-select"
import MetaTags from "react-meta-tags"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import * as Yup from "yup"
import { dateformat } from "config"
import { useFormik } from "formik"
import Switch from "react-switch"
import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"
import { getSettingData } from "../../store/settings/actions"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import {
  getUsers as onGetUsers,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
  clearMessage,
  resetData,
} from "store/user/actions"
import { getRoles as onGetRoles } from "../../store/roles/actions"
import { isEmpty, map, orderBy } from "lodash"
import moment from "moment"
import { statusTypes, messageTitle, vehicleTypes } from "../../constants/common"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
import { mobileRegex, iuRegex,vehicleRegex } from "../../helpers/validator"
import { getSeasonPasses as onGetSeasonPasses } from "store/season-pass/actions"

import toastr from "toastr"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import DeleteModal from "components/Common/DeleteModal"
import "toastr/build/toastr.min.css"
//redux
import { useSelector, useDispatch } from "react-redux"
const defaultDate = moment()

const sizePerPage = 25

const checkStatus = status => {
  if (status == statusTypes.Removed || status == statusTypes.Rejected) {
    return true
  } else {
    return false
  }
}

const getPMS = user => {
  if (!isEmpty(user)) {
    return {
      value: user?.primaryStation || "",
      label: user?.primaryStation || "",
    }
  }
  return null
}

const getRole = role => {
  if (role) {
    return {
      value: role?._id || "",
      label: role?.roleTitle || "",
    }
  }
  return null
}

const getSeason = seasonPass => {
  if (seasonPass) {
    return {
      value: seasonPass?._id || "",
      label: seasonPass?.seasonTitle || "",
      type: seasonPass?.seasonType || "",
    }
  }
  return null
}

const getTempVehicle = user => {
  if (!isEmpty(user)) {
    return user?.tempVehicle
  }
  return true
}

const getScheduleChangeDate = user => {
  if (!isEmpty(user)) {
    const schedule = Object.keys(user?.scheduled || []).find(
      el => el.updateField == "name"
    )
    if (schedule && !isEmpty(schedule)) {
      return schedule.dateScheduled
    }
  }
  return defaultDate
}

function UserApproval(props) {
  const dispatch = useDispatch()
  const [user, setUser] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [isEdit, setIsEdit] = useState(false)
  const [selectedRole, setSelectedRole] = useState(getRole(user?.role || null))
  const [selectedSeason, setSeason] = useState(getSeason(user?.season || null))
  const [selectedPMS, setPMS] = useState(getPMS(user))
  const [primaryStations, setPrimaryStations] = useState([])
  const [customValidation, setCustValidation] = useState({
    validPMS: true,
  })

  const [loading, setLoading] = useState(false)
  const [scheduleChange, setScheduleChange] = useState(false)
  const [vehicleType, setVehicleType] = useState(vehicleTypes.car)
  const [autoPay,setAutoPay]=useState(true)


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (user && user.name) || "",
      department: (user && user.department) || "",
      email: (user && user.email) || "",
      mobileNumber: (user && user.mobileNumber) || "",
      vehicleNumber: (user && user.vehicleNumber) || "",
      inVehicleUnit: (user && user.inVehicleUnit) || "",
      tempVehicleExpiryDate: (user && user.tempVehicle && user.tempVehicle.endDate) || null,
      tempVehicleNo: (user && user.tempVehicle && user.tempVehicle.tempVehicleNo) || "",
      tempInVehicleUnit: (user && user.tempVehicle && user.tempVehicle.tempInVehicleUnit) || "",
      tempVehicleReason: (user && user.tempVehicle && user.tempVehicle.reason) || "",
      scheduleChangeDate: convertUtcToLocal(
        getScheduleChangeDate(user || null)
      ),
      seasonStartDate: (user && user.seasonStartDate) || moment().add(1, "M").startOf("months"),
      approveStartDate: (user && user.seasonStartDate) || moment().add(1, "M").startOf("months"),
      autoPay: (user && user.autoPay) || "true",
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required("Please Enter Your Name")
        .min(5, "Must be at least 5 characters"),
      mobileNumber: Yup.string()
        .required("A valid Mobile Number is required")
        .matches(mobileRegex, "Invalid Mobile Number")
        .min(8, "Invalid Mobile Number")
        .max(8, "Invalid Mobile Number"),
      email: Yup.string()
        .required("Please Enter Your Email")
        .email("A valid Corporate Email is required")
        .max(255),
      vehicleNumber: Yup.string()
        .required("A valid Vehicle Number is required")
        .matches(vehicleRegex, "Invalid Vehicle Number","Invalid Vehicle Number")
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      inVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleNo: Yup.string()
        .matches(vehicleRegex,"Invalid Vehicle Number" )
        .max(8, "Invalid Vehicle Number")
        .min(3, "Invalid Vehicle Number"),
      tempInVehicleUnit: Yup.string()
        .matches(iuRegex, "Invalid In-Unit Vehicle Number")
        .max(10, "Invalid In-Unit Vehicle Number")
        .min(10, "Invalid In-Unit Vehicle Number"),
      tempVehicleExpiryDate: Yup.date().nullable(),
      seasonStartDate: Yup.date().required("Please enter Date"),
      approveStartDate: Yup.date().required("Please enter Date"),
    }),
    onSubmit: values => {
      if (isEdit) {
        let updateUser = {
          id: user.id,
          name: values.name,
          role: selectedRole?.value || "",
          season: selectedSeason?.value || "",
          seasonType: selectedSeason?.type || user?.seasonType|| "",
          corporateEmail: values.email,
          department: values.department,
          mobileNumber: values.mobileNumber,
          inVehicleUnit: values.inVehicleUnit,
          vehicleNumber: values.vehicleNumber,
          primaryStation: selectedPMS?.value || "",
          vehicleType,
          seasonStartDate: moment(values.seasonStartDate).utc(),
          autoPay:values.autoPay,
          nextBillDate: moment(user.nextBillDate).diff(values.seasonStartDate, "days") > 0 ?
            moment(user.nextBillDate).utc() : moment(values.seasonStartDate).utc(),

        }
        if (scheduleChange) {
          let _scheduleObj = []
          if (user?.name != updateUser?.name) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "name",
              updateData: updateUser?.name,
            })
            delete updateUser?.name
          }
          if (user?.role?._id != updateUser?.role) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "role",
              updateData: updateUser?.role,
            })
            delete updateUser?.role
          }
          if (user?.season?._id != updateUser?.season) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "season",
              updateData: updateUser?.season,
            })
            delete updateUser?.season
          }
          if (user?.corporateEmail != updateUser?.corporateEmail) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "corporateEmail",
              updateData: updateUser?.corporateEmail,
            })
            delete updateUser?.corporateEmail
          }
          if (user?.department != updateUser?.department) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "department",
              updateData: updateUser?.department,
            })
            delete updateUser?.department
          }
          if (user?.mobileNumber != updateUser?.mobileNumber) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "mobileNumber",
              updateData: updateUser?.mobileNumber,
            })
            delete updateUser?.mobileNumber
          }
          if (user?.inVehicleUnit != updateUser?.inVehicleUnit) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "inVehicleUnit",
              updateData: updateUser?.inVehicleUnit,
            })
            delete updateUser?.inVehicleUnit
          }
          if (user?.vehicleNumber != updateUser?.vehicleNumber) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "vehicleNumber",
              updateData: updateUser?.vehicleNumber,
            })
            delete updateUser?.vehicleNumber
          }
          if (user?.primaryStation != updateUser?.primaryStation) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "primaryStation",
              updateData: updateUser?.primaryStation,
            })
            delete updateUser?.primaryStation
          }
          if (user?.seasonStartDate != updateUser?.seasonStartDate) {
            _scheduleObj.push({
              dateScheduled: convertDateToUtc(values["scheduleChangeDate"]),
              updateField: "seasonStartDate",
              updateData: updateUser?.seasonStartDate,
            })
            delete updateUser?.seasonStartDate
          }

          if (!isEmpty(_scheduleObj)) {
            updateUser = {
              ...updateUser,
              scheduled: _scheduleObj,
            }
          }
        }
        if (
          !isEmpty(values.tempInVehicleUnit) &&
          !isEmpty(values.tempVehicleExpiryDate) &&
          !isEmpty(tempVehicleReason)
        ) {
          updateUser = {
            ...updateUser,
            tempVehicle: {
              startDate: convertDateToUtc(defaultDate),
              endDate: convertDateToUtc(values.tempVehicleExpiryDate),
              tempInVehicleUnit: values.tempInVehicleUnit,
              tempVehicleNo: values.tempVehicleNo,
              reason: values.tempVehicleReason,
              status: "Approved",
            },
          }
        }
        // update user
        setLoading(true)
        dispatch(onUpdateUser(updateUser))
        validation.resetForm()
        setIsEdit(false)
      } else {
        const newUser = {
          name: values["name"],
          role: selectedRole?.value || "",
          season: selectedSeason?.value || "",
          corporateEmail: values["email"],
          department: values["department"],
          mobileNumber: values["mobileNumber"],
          vehicleNumber: values["vehicleNumber"],
          inVehicleUnit: values["inVehicleUnit"],
          tempVehicle: null,
          scheduled: null,
          transactions: null,
          status: "Approved",
          primaryStation: selectedPMS?.value || "",
          vehicleType,
          seasonStartDate: values["seasonStartDate"],
          nextBillDate: values["seasonStartDate"],
          autoPay:values["autoPay"]
        }
        setLoading(true)
        // save new user
        dispatch(onAddNewUser(newUser))
      }
      toggle()
    },
  })

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false)

  const handleDeleteUser = () => {
    setLoading(true)
    if (user.action == "delete") {
      dispatch(onDeleteUser(user))
    } else if (user.action == "approve") {
      const updateUser = {
        id: user._id,
        seasonStartDate: moment(validation.values.seasonStartDate).utc(),
        nextBillDate: moment(user.nextBillDate).diff(validation.values.seasonStartDate, "days") > 0 ?
          moment(user.nextBillDate).utc() : moment(validation.values.seasonStartDate).utc(),
        status: statusTypes.Approved,
      }
      dispatch(onUpdateUser(updateUser))
    } else {
      dispatch(onDeleteUser(user))
    }
    //onPaginationPageChange(currentPage)
    setDeleteModal(false)
  }

  const {
    users,
    roleList,
    seasonPassList,
    settingData,
    message,
    pagination,
    error,
  } = useSelector(state => ({
    users: (state.users.userList||[]).filter(el => el?.status == statusTypes.Pending),
    pagination: state.users.pagination,
    message: state.users.message,
    settingData: state.Settings.settingData,
    seasonPassList: state.seasonPass?.seasonPassList || [],
    roleList: state.roles.roleList,
    error: state.users.error,
  }))
  const [modal, setModal] = useState(false)
  const [reasonText, setReasonText] = useState("")
  const { SearchBar } = Search
  const [searchKey, setSearchKey] = useState("");

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0,
    custom: true,
    totalPages: pagination?.totalPages || 0,
  }

  useEffect(()=>{
    if (searchKey.length >= 2 || searchKey == "") {
      dispatch(onGetUsers({ status: [
        statusTypes.Pending,
      ],
      search: searchKey, }));
    }
  },[searchKey]);

  const defaultSorted = [
    {
      dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
      order: "desc", // desc or asc
    },
  ]
  useEffect(() => {
    dispatch(onGetUsers({ status: [statusTypes.Pending], search: searchKey }))
    return function cleanup() {
      dispatch(resetData())
    }
  }, [])

  useEffect(() => {
    setLoading(true)
    dispatch(getSettingData())
    // dispatch(onGetUsers())
    dispatch(onGetRoles())
    dispatch(
      onGetSeasonPasses({
        status: statusTypes.Available,
      })
    )
    return function cleanup() {
      dispatch(resetData())
    }
  }, [])

  useEffect(() => {
    if (settingData["cpfProperties"]) {
      const { cpfBuilding } = settingData["cpfProperties"]
      const list = !isEmpty(cpfBuilding) ? cpfBuilding.split(`,`) : []
      setPrimaryStations(list)
    }
  }, [settingData])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
        //dispatch(onGetUsers({ status: [statusTypes.Pending] }))
      }, 500)
    }
  }, [dispatch, error])

  useMemo(() => {
    if (message) {
      dispatch(onGetUsers({ status: [statusTypes.Pending], search: searchKey }))
      toastr.success(message, messageTitle)
      setModal(false)
      setUser(null)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message])

  const toggle = () => {
    setModal(!modal)
  }

  const handleApproveRejectClick = (user, status) => {
    setDeleteModal(true)
    setUser({ ...user, status: status })
  }

  const handleUpdateClick = () => {
    let updateUser = {
      status: user.status,
      seasonStartDate: moment(validation.values.approveStartDate).utc(),
      nextBillDate: moment(user.nextBillDate).diff(validation.values.approveStartDate, "days") > 0 ?
        moment(user.nextBillDate).utc() : moment(validation.values.approveStartDate).utc(),
      id: user._id,
      statusChangeReason: reasonText,
    }
    dispatch(onUpdateUser(updateUser))
    setDeleteModal(false)
  }

  const handleUserClick = arg => {
    const user = arg
    setUser({
      ...user,
      id: user._id,
      name: user.name,
      seasonType: user.seasonType,
      email: user.corporateEmail,
      department: user.department,
      mobileNumber: user.mobileNumber,
      vehicleNumber: user.vehicleNumber,
      inVehicleUnit: user.inVehicleUnit,
      seasonStartDate: moment(user.seasonStartDate).utc(),
    })
    setSelectedRole(getRole(user?.role || null))
    setSeason(getSeason(user?.season || null))
    setIsEdit(true)
    setScheduleChange(user?.scheduled ? true : false)
    setPMS(getPMS(user))
    if (user.vehicleType == vehicleTypes.bike) {
      setVehicleType(vehicleTypes.bike)
    } else {
      setVehicleType(vehicleTypes.car)
    }
    toggle()
  }

  const userListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user._id}</>,
    },
    {
      text: "User ID",
      dataField: "userId",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => <>{user.userId}</>,
    },
    {
      text: "Name",
      dataField: "name",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.name}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.role?.roleTitle || ""}</p>
        </>
      ),
    },
    {
      text: "Employment Details",
      dataField: "department",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user?.primaryStation || ""}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.department || ""}</p>
        </>
      ),
    },
    {
      dataField: "corporateEmail",
      text: "Contact Details",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user.mobileNumber}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.corporateEmail || ""}</p>
        </>
      ),
    },

    {
      dataField: "vehicleNumber",
      text: "Vehicle Details",
      sort: true,
      formatter: (cellContent, user) => (
        <>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {user?.vehicleNumber || ""}
            </Link>
          </h5>
          <p className="text-muted mb-0">{user?.inVehicleUnit || ""}</p>
        </>
      ),
    },
    {
      dataField: "user.season",
      text: "Season Selected",
      sort: true,
      formatter: (cellContent, user) => {
        return (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {user?.season?.seasonTitle || ""}
              </Link>
            </h5>
          </>
        )
      },
    },
    {
      text: "Date Applied",
      dataField: "purpose",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <div style={{ whiteSpace: "normal" }}>
            {moment(convertUtcToLocal(record?.createdAt)).format("DD-MM-YYYY")}
          </div>
        )
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, user) => (
        <div className="d-flex gap-3">
          <Link
            className="text-primary"
            to="#"
            style={{
              opacity: checkStatus(user?.status) ? "0.4" : 5,
              pointerEvents: checkStatus(user?.status) ? "none" : "auto",
            }}
          >
            <i
              className="mdi mdi-account-edit font-size-24"
              id="edittooltip"
              // style={{ opacity: "0.4", cursor: "default" }}
              onClick={e => handleUserClick(user)}
              data-toggle="tooltip"
              data-placement="top"
              title="Update User" // Changes on hover text
            ></i>
          </Link>
          <Link className="text-success" to="#">
            <i
              className="mdi mdi-account-check font-size-24"
              id="edittooltip"
              // onClick={() => onClickDelete(user)}
              onClick={() =>
                handleApproveRejectClick(user, statusTypes.Approved)
              }
              data-toggle="tooltip"
              data-placement="top"
              title="Approve User" // Changes on hover text
            ></i>
          </Link>
          <Link className="text-dark" to="#">
            <i
              className="mdi mdi-account-remove font-size-24"
              id="deletetooltip"
              onClick={() =>
                handleApproveRejectClick(user, statusTypes.Rejected)
              }
              // onClick={() => onClickDelete(user)}
              data-toggle="tooltip"
              data-placement="top"
              title="Reject User" // Changes on hover text
            ></i>
          </Link>
        </div>
      ),
    },
  ]

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  const keyField = "_id"

  const roleOptions = (roleList || []).map(el => ({
    value: el._id,
    label: el.roleTitle,
  }))
  const _seasonPasses = (seasonPassList || []).filter(el => {
    if (selectedRole) {
      return el.vehicleType == vehicleType &&
             el.roleApplicable.includes(selectedRole.value)
    } else {
      return  el.vehicleType == vehicleType
    }
  })

  const seasonTypeOptions = map(_seasonPasses || [], el => {
    return {
      value: el._id,
      label: el.seasonTitle,
      type: el.seasonType,
    }
  })

  delete statusTypes.Offline

  let statusTypeOptions = map(statusTypes, (key, i) => {
    return {
      value: `${key}`,
      label: `${statusTypes[key]}`,
    }
  })
  statusTypeOptions.unshift({ value: "All", label: "All" })

  const stationOptions = map(primaryStations, el => {
    return {
      value: `${el.trim()}`,
      label: `${el.trim()}`,
    }
  })

  let rows = []
  if (user) {
    rows.push(user.id)
  }

  const _expiryDate = validation.values.tempVehicleExpiryDate
    ? moment(convertUtcToLocal(validation.values.tempVehicleExpiryDate)).format(
      dateformat.default
    )
    : ""

  const _scheduleChangeDate = validation.values.scheduleChangeDate
    ? moment(convertUtcToLocal(validation.values.scheduleChangeDate)).format(
      dateformat.default
    )
    : ""

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        // onDeleteClick={handleDeleteUser}
        onDeleteClick={handleUpdateClick}
        onCloseClick={() => setDeleteModal(false)}
        title={
          user?.status == statusTypes.Approved
            ? `Approve, ${user?.name}?`
            : `Reject, ${user?.name}?`
        }
        text={
          user?.status == statusTypes.Approved
            ? "Yes, Approve it!"
            : "Yes, Reject it!"
        }
        icon={
          user?.status == statusTypes.Approved
            ? "mdi mdi-account-check"
            : "mdi mdi-account-remove"
        }
        iconColor={
          user?.status == statusTypes.Approved ? "text-success" : "text-dark"
        }
        childComponent={
          user?.status == statusTypes.Approved ? (
            <div>
              <Row><h4>{"You won't be able to revert this!"}</h4></Row>
              <Row>
                <Col md={5} className="p-0">
                  {/*<Label className="form-label" htmlFor="startDate2">
                  Season start date*
                  </Label>
                  */}
                  <h5 className="mt-2">Season start date</h5>
                </Col>
                <Col className="p-0">
                  <input
                    className="form-control"
                    type="date"
                    placeholder={
                      "DD-MM-YYYY"
                    }
                    min={moment().format(
                      "YYYY-MM-DD"
                    )}
                    name="approveStartDate"
                    onChange={
                      validation.handleChange
                    }
                    onBlur={
                      validation.handleBlur
                    }
                    value={
                      moment(validation.values.approveStartDate).
                        format("YYYY-MM-DD")
                    }
                  />
                  {validation.touched
                    .approveStartDate &&
                    validation.errors
                      .approveStartDate ? (
                    <FormFeedback type="invalid">
                      {
                        validation.errors
                          .approveStartDate
                      }
                    </FormFeedback>
                  ) : null}
                </Col>
              </Row>
            </div>
          ) : (
            <textarea
              name="reasonText"
              className="form-control"
              id="reasonText"
              rows="2"
              onChange={e => setReasonText(e.target.value)}
              onBlur={e => setReasonText(e.target.value)}
              value={reasonText || ""}
            />
          )
        }
      />
      <div className="page-content">
        <MetaTags>
          <title>Manage User Approvals | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Users" breadcrumbItem="Manage User Approvals" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField={keyField}
                    columns={userListColumns}
                    data={users || []}
                  >
                    {({ paginationProps, paginationTableProps }) => {
                      return (
                        
                      )
                    }}
                  </PaginationProvider> */}
                  <ToolkitProvider
                    keyField={keyField}
                    data={users || []}
                    columns={userListColumns}
                    bootstrap4
                    search
                  >
                    {toolkitProps => (
                      <React.Fragment>
                        <Row className="mb-2">
                          <Col sm="4">
                            <div className="search-box ms-2 mb-2 d-inline-block">
                              <div className="position-relative">
                                {/* <SearchBar
                                  {...toolkitProps.searchProps}
                                /> */}
                                <input
                                  id="search-bar-0"
                                  type="text"
                                  className="form-control "
                                  placeholder="Search"
                                  value={searchKey}
                                  onChange={e => setSearchKey(e.target.value)}
                                />
                                <i className="bx bx-search-alt search-icon" />
                              </div>
                            </div>
                          </Col>
                          <Col sm="8"></Col>
                        </Row>
                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={keyField}
                                {...toolkitProps.baseProps}
                                // {...paginationTableProps}
                                defaultSorted={defaultSorted}
                                classes={
                                  "table align-middle table-nowrap table-hover"
                                }
                                bordered={false}
                                striped={false}
                                responsive
                                ref={node}
                                noDataIndication={emptyDataMessage}
                              />

                              <Modal
                                isOpen={modal}
                                toggle={toggle}
                                className={"modal-lg"}
                              >
                                <ModalHeader toggle={toggle} tag="h4">
                                  {!!isEdit
                                    ? "Update User"
                                    : "Add New User"}
                                </ModalHeader>
                                <ModalBody>
                                  <Form
                                    onSubmit={e => {
                                      e.preventDefault()
                                      validation.handleSubmit()
                                      return false
                                    }}
                                  >
                                    <Row>
                                      <Col xs={12}>                                        
                                        <div className="mb-3">
                                          <Row>
                                            <Col md={6}>
                                              <label className="form-label">
                                                Role
                                              </label>
                                              <Select
                                                name="role"
                                                value={selectedRole}
                                                onChange={e => {
                                                  setSelectedRole(e)
                                                }}
                                                options={roleOptions}
                                                classNamePrefix="select2-selection"
                                              />
                                            </Col>
                                            <Col md={6}>
                                              <Label className="form-label">
                                                Primary Location
                                              </Label>
                                              <Select
                                                name={"primaryStation"}
                                                value={selectedPMS}
                                                onChange={e => {
                                                  setCustValidation({
                                                    validPMS: true,
                                                  })
                                                  setPMS(e)
                                                }}
                                                options={stationOptions}
                                                classNamePrefix="select2-selection"
                                              />

                                              {!customValidation.validPMS && (
                                                <div
                                                  className="invalid-feedback"
                                                  style={{
                                                    display: "block",
                                                  }}
                                                >
                                                  Please select primary
                                                  station
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="mb-3">
                                          <Row>
                                            <Col md={7}>
                                              <Label className="form-label">
                                                Department / Company Name
                                              </Label>
                                              <Input
                                                name="department"
                                                //label="Department / Tenanted Site"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .department || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .department &&
                                                    validation.errors
                                                      .department
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .department &&
                                                validation.errors
                                                  .department ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .department
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </Col>
                                            <Col md={5}>
                                              <Label className="form-label">
                                                Name*
                                              </Label>
                                              <Input
                                                name="name"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .name || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .name &&
                                                    validation.errors.name
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched.name &&
                                                validation.errors.name ? (
                                                <FormFeedback type="invalid">
                                                  {validation.errors.name}
                                                </FormFeedback>
                                              ) : null}
                                            </Col>
                                          </Row>
                                        </div>

                                        <div className="mb-3">
                                          <Row>
                                            <Col md={7}>
                                              <Label className="form-label">
                                                Email*
                                              </Label>
                                              <Input
                                                name="email"
                                                label="Email"
                                                type="email"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .email || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .email &&
                                                    validation.errors.email
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched.email &&
                                                validation.errors.email ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .email
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </Col>
                                            <Col md={5}>
                                              <Label className="form-label">
                                                Mobile Number*
                                              </Label>
                                              <Row>
                                                <Col sm={12}>
                                                  <InputGroup className="mb-2">
                                                    <div className="input-group-prepend">
                                                      <span className="input-group-text">
                                                        +65
                                                      </span>
                                                    </div>
                                                    <Input
                                                      name="mobileNumber"
                                                      label="mobileNumber"
                                                      type="text"
                                                      onChange={
                                                        validation.handleChange
                                                      }
                                                      onBlur={
                                                        validation.handleBlur
                                                      }
                                                      value={
                                                        validation.values
                                                          .mobileNumber ||
                                                        ""
                                                      }
                                                      invalid={
                                                        validation.touched
                                                          .mobileNumber &&
                                                          validation.errors
                                                            .mobileNumber
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  </InputGroup>
                                                  {validation.touched
                                                    .mobileNumber &&
                                                    validation.errors
                                                      .mobileNumber ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .mobileNumber
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                              </Row>
                                            </Col>
                                          </Row>
                                        </div>
                                        <div className="mb-3">
                                          <h5 className="font-size-14 mb-3 mt-4">
                                            Primary Vehicle
                                          </h5>
                                        </div>
                                        <div className="mb-3">
                                          <Row>
                                            <Col md={3}>
                                              <Row>
                                                <Col>
                                                  <div className="form-check mt-2">
                                                    <input
                                                      type="radio"
                                                      id="customRadio1"
                                                      name="customRadio"
                                                      className="form-check-input"
                                                      defaultChecked={
                                                        vehicleType ==
                                                        vehicleTypes.car
                                                      }
                                                      onChange={e =>
                                                        setVehicleType(
                                                          vehicleTypes.car
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="customRadio1"
                                                    >
                                                      Car
                                                    </label>
                                                  </div>
                                                </Col>                                              
                                                <Col>
                                                  <div className="form-check mt-2">
                                                    <input
                                                      type="radio"
                                                      id="customRadio2"
                                                      name="customRadio"
                                                      className="form-check-input"
                                                      defaultChecked={
                                                        vehicleType ==
                                                        vehicleTypes.bike
                                                      }
                                                      onChange={e =>
                                                        setVehicleType(
                                                          vehicleTypes.bike
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      htmlFor="customRadio2"
                                                    >
                                                      Bike
                                                    </label>
                                                  </div>
                                                </Col>
                                              </Row>
                                            </Col>
                                            <Col md={4}>
                                              <Label className="form-label">
                                                Vehicle Number*
                                              </Label>
                                              <Input
                                                name="vehicleNumber"
                                                label="vehicleNumber"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .vehicleNumber || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .vehicleNumber &&
                                                    validation.errors
                                                      .vehicleNumber
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .vehicleNumber &&
                                                validation.errors
                                                  .vehicleNumber ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .vehicleNumber
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </Col>
                                            <Col md={4}>
                                              <Label className="form-label">
                                                In Vehicle Unit*
                                              </Label>
                                              <Input
                                                name="inVehicleUnit"
                                                label="inVehicleUnit"
                                                type="text"
                                                onChange={
                                                  validation.handleChange
                                                }
                                                onBlur={
                                                  validation.handleBlur
                                                }
                                                value={
                                                  validation.values
                                                    .inVehicleUnit || ""
                                                }
                                                invalid={
                                                  validation.touched
                                                    .inVehicleUnit &&
                                                    validation.errors
                                                      .inVehicleUnit
                                                    ? true
                                                    : false
                                                }
                                              />
                                              {validation.touched
                                                .inVehicleUnit &&
                                                validation.errors
                                                  .inVehicleUnit ? (
                                                <FormFeedback type="invalid">
                                                  {
                                                    validation.errors
                                                      .inVehicleUnit
                                                  }
                                                </FormFeedback>
                                              ) : null}
                                            </Col>                                            
                                          </Row>
                                        </div>
                                        {isEdit && (
                                          <>
                                            <div className="mb-3">
                                              <h5 className="font-size-14 mb-3 mt-4">
                                                Temporary Vehicle
                                              </h5>
                                            </div>
                                            <div className="mb-3">
                                              <Row>
                                                <Col md={4}>
                                                  <Label className="form-label">
                                                    Vehicle Number*
                                                  </Label>
                                                  <Input
                                                    name="tempVehicleNo"
                                                    label="tempVehicleNo"
                                                    type="text"
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                    value={
                                                      validation.values
                                                        .tempVehicleExpiryDate ||
                                                      ""
                                                    }
                                                    invalid={
                                                      validation.touched
                                                        .tempVehicleExpiryDate &&
                                                        validation.errors
                                                          .tempVehicleExpiryDate
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {validation.touched
                                                    .tempVehicleNo &&
                                                    validation.errors
                                                      .tempVehicleNo ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .tempVehicleNo
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                                <Col md={8}>
                                                  <Label className="form-label">
                                                    In Vehicle Unit*
                                                  </Label>
                                                  <Input
                                                    name="tempInVehicleUnit"
                                                    label="tempInVehicleUnit"
                                                    type="text"
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                    value={
                                                      validation.values
                                                        .tempInVehicleUnit ||
                                                      ""
                                                    }
                                                    invalid={
                                                      validation.touched
                                                        .tempInVehicleUnit &&
                                                        validation.errors
                                                          .tempInVehicleUnit
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {validation.touched
                                                    .tempInVehicleUnit &&
                                                    validation.errors
                                                      .tempInVehicleUnit ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .tempInVehicleUnit
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                              </Row>
                                            </div>
                                            <div className="mb-3">
                                              <Row>
                                                <Col md={4}>
                                                  <Label className="form-label">
                                                    Expiry Date*
                                                  </Label>
                                                  <input
                                                    className="form-control"
                                                    type="date"
                                                    placeholder={
                                                      "DD-MM-YYYY"
                                                    }
                                                    defaultValue={
                                                      _expiryDate
                                                    }
                                                    min={moment().format(
                                                      "YYYY-MM-DD"
                                                    )}
                                                    id="tempVehicleExpiryDate"
                                                    name="tempVehicleExpiryDate"
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                  />
                                                  {validation.touched
                                                    .tempVehicleExpiryDate &&
                                                    validation.errors
                                                      .tempVehicleExpiryDate ? (
                                                    <FormFeedback type="invalid">
                                                      {
                                                        validation.errors
                                                          .tempVehicleExpiryDate
                                                      }
                                                    </FormFeedback>
                                                  ) : null}
                                                </Col>
                                                <Col md={8}>
                                                  <Label className="form-label">
                                                    Reason
                                                  </Label>
                                                  <textarea
                                                    name="tempVehicleReason"
                                                    className="form-control"
                                                    id="tempVehicleReason"
                                                    rows="3"
                                                    onChange={
                                                      validation.handleChange
                                                    }
                                                    onBlur={
                                                      validation.handleBlur
                                                    }
                                                    value={
                                                      validation.values
                                                        .tempVehicleReason ||
                                                      ""
                                                    }
                                                  ></textarea>
                                                </Col>
                                              </Row>
                                            </div>
                                            <div className="mb-3"></div>
                                          </>
                                        )}
                                      </Col>
                                    </Row>
                                    <div className="mb-3">
                                      <h5 className="font-size-14 mb-3 mt-4">
                                        Season
                                      </h5>
                                    </div>
                                    <div className="mb-3">
                                      <Row>
                                        <Col md={2}>
                                          <Label className="form-check-label">
                                            Auto Pay
                                          </Label>
                                          <Switch
                                            checked={autoPay}
                                            onColor="#626ed4"
                                            onChange={e => {
                                              setAutoPay(!autoPay)
                                            }}
                                            uncheckedIcon={
                                              <OffSymbol text="Off" />
                                            }
                                            checkedIcon={
                                              <OnSymbol text="On" />
                                            }
                                          />
                                        </Col>
                                        <Col md={3}>
                                          <Label className="form-label" htmlFor="seasonStartDate">
                                            Season start date*
                                          </Label>
                                          <input
                                            className="form-control"
                                            type="date"
                                            placeholder={
                                              "DD-MM-YYYY"
                                            }
                                            value={moment(convertUtcToLocal(validation.values.seasonStartDate))
                                              .format("YYYY-MM-DD")
                                            }
                                            min={moment().format(
                                              "YYYY-MM-DD"
                                            )}
                                            name="seasonStartDate"
                                            onChange={
                                              validation.handleChange
                                            }
                                            onBlur={
                                              validation.handleBlur
                                            }
                                          />
                                          {validation.touched
                                            .seasonStartDate &&
                                            validation.errors
                                              .seasonStartDate ? (
                                            <FormFeedback type="invalid">
                                              {
                                                validation.errors
                                                  .seasonStartDate
                                              }
                                            </FormFeedback>
                                          ) : null}
                                        </Col>

                                        <Col md={7}>
                                          <label className="form-label">
                                            Season Type
                                          </label>
                                          <Select
                                            name={"seasonType"}
                                            value={selectedSeason}
                                            onChange={e => {
                                              setSeason(e)
                                            }}
                                            options={seasonTypeOptions}
                                            classNamePrefix="select2-selection"
                                          />
                                        </Col>
                                      </Row>
                                    </div>
                                    <Row>
                                      <Col className="mt-4">
                                        <div className="text-end">
                                          <button
                                            type="submit"
                                            className="btn btn-success save-user"
                                          >
                                            Update User
                                          </button>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Form>
                                </ModalBody>
                              </Modal>
                            </div>
                          </Col>
                        </Row>
                        {/* <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row> */}
                      </React.Fragment>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

UserApproval.propTypes = {}

export default withRouter(UserApproval)
